import styled from "styled-components";

export const SelectWrapper = styled.div`
  position: relative;
  font-family: inherit;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
`;

export const Input = styled.div`
  font-family: "Nunito";
  font-size: 16px;
  border: 1px solid #ccc;
  padding: 0px 8px;
  border-radius: 4px;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
  min-height: 32px;
`;

export const InputContent = styled.div`
  font-family: "Nunito";
  font-size: 16px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f7f7f7;
  display: flex;
  justify-content: space-between;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  max-width: 90%;
  align-items: center;
`;

export const InputContentText = styled.p`
  font-family: "Nunito";
  font-size: 16px;
  margin: 0;
  padding-right: 2px;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InputPlaceholder = styled.div`
  font-family: "Nunito";
  font-size: 16px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #808080;
`;

export const InputActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Divider = styled.div`
  height: 60%;
  border-left: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
`;

export const OptionList = styled.ul`
  font-family: "Nunito";
  font-size: 16px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  z-index: 10;
  margin-top: 4px;
  padding: 0;
  list-style: none;
`;

export const OptionItem = styled.li`
  font-family: "Nunito";
  font-size: 16px;
  padding: 8px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? "#f4f4f4" : "white")};

  &:hover {
    background-color: #eee;
  }

  span {
    float: right;
    color: red;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  margin-left: auto;
  cursor: pointer;

  &:focus,
  &:active {
    outline: none;
  }
`;
